import { atom, useSetAtom } from 'jotai';

export interface themeProps {
  modalBackground?: string;
  cardColor?: string;
  textColor?: string;
  secondaryTextColor?: string;
  buttonColor?: string;
  buttonTextColor?: string;
  buttonShadow?: string;
  dropDownBorder?: string;
}

// Global Theme object with default theme settings
export const themeAtom = atom<themeProps>({
  modalBackground: 'bg-black/25',
  cardColor: 'bg-[#051C48]',
  textColor: 'text-white',
  secondaryTextColor: 'text-white',
  buttonColor: '!bg-blue-100',
  buttonTextColor: 'text-blue-900',
  buttonShadow: '',
  dropDownBorder: '',
});

// Updates global theme with new themeAtom object
export const useUpdateTheme = () => {
  const setTheme = useSetAtom(themeAtom);

  const updateTheme = (NewTheme: Partial<themeProps>) => {
    setTheme((currentTheme) => ({
      ...currentTheme,
      ...NewTheme,
    }));
  };

  return updateTheme;
};
